import { Box } from '@mui/system';
import { ButtonBase, List, ListItem, Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NotificationMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    border: '1px solid #DFE5EE',
    borderRadius: 16,
    boxShadow: '0 18px 48px rgba(16, 24, 40, 0.18)',
    width: 'min(400px, calc(100vw - 24px))',
  },
  '& .MuiList-root.MuiMenu-list': {
    maxHeight: 'min(560px, calc(100dvh - 92px))',
    overflowY: 'auto',
    padding: 0,
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiPaper-root': {
      borderRadius: 14,
    },
  },
}));

export const NotificationHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #E8EDF4',
  display: 'flex',
  gap: theme.spacing(1.5),
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.25),
  position: 'sticky',
  top: 0,
  zIndex: 2,
  '& h2': {
    color: '#101828',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '24px',
  },
  '& p': {
    color: '#667085',
    fontSize: 12,
    lineHeight: '18px',
    marginTop: 2,
  },
  '& .MuiButton-root': {
    borderRadius: 8,
    color: theme.palette.primary.main,
    flexShrink: 0,
    fontSize: 12,
    fontWeight: 700,
    minHeight: 36,
    padding: theme.spacing(0.75, 1),
    textTransform: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    '& .MuiButton-root': {
      '& .MuiButton-startIcon': {
        marginRight: 4,
      },
    },
  },
}));

export const NotificationItems = styled(List)(() => ({
  display: 'block',
  padding: 0,
}));

export const NotificationListItem = styled(ListItem)(() => ({
  display: 'block',
  margin: 0,
  padding: 0,
}));

export const NotificationLink = styled(ButtonBase)(({ theme }) => ({
  alignItems: 'flex-start',
  appearance: 'none',
  backgroundColor: '#F5F8FC',
  border: 0,
  borderBottom: '1px solid #E8EDF4',
  borderLeft: `3px solid ${theme.palette.primary.main}`,
  color: 'inherit',
  cursor: 'pointer',
  display: 'flex',
  font: 'inherit',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.75, 2),
  textAlign: 'left',
  textDecoration: 'none',
  transition: 'background-color 160ms ease, border-color 160ms ease',
  width: '100%',
  '&.read': {
    backgroundColor: '#FFFFFF',
    borderLeftColor: 'transparent',
  },
  '&:hover, &:focus-visible': {
    backgroundColor: '#EDF4FD',
    outline: 'none',
  },
  '&:focus-visible': {
    boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`,
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1.25),
    padding: theme.spacing(1.5),
  },
}));

export const ListItemData = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
  '& .notification-title-row': {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    minWidth: 0,
  },
  '& .unread-dot': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    flex: '0 0 auto',
    height: 8,
    width: 8,
  },
  '& h6': {
    color: '#101828',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '20px',
    overflowWrap: 'anywhere',
    whiteSpace: 'normal',
  },
  '& p': {
    color: '#475467',
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '19px',
    marginTop: theme.spacing(0.4),
    overflowWrap: 'anywhere',
    whiteSpace: 'normal',
  },
  '& span': {
    color: '#667085',
    fontSize: 11.5,
    fontWeight: 500,
    lineHeight: '17px',
    marginTop: theme.spacing(0.75),
  },
}));

export const NotificationFooter = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderTop: '1px solid #E8EDF4',
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(1),
  position: 'sticky',
  zIndex: 2,
  '& .MuiButton-root': {
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 700,
    minHeight: 38,
    textTransform: 'none',
    width: '100%',
  },
}));

export const NoNotification = styled(ListItem)(({ theme }) => ({
  alignItems: 'center',
  border: 'none',
  color: '#667085',
  display: 'flex',
  flexDirection: 'column',
  fontSize: 13,
  gap: theme.spacing(0.75),
  justifyContent: 'center',
  lineHeight: '18px',
  minHeight: 190,
  padding: theme.spacing(3, 2),
  textAlign: 'center',
  '& strong': {
    color: '#101828',
    fontSize: 14,
    marginTop: theme.spacing(0.75),
  },
}));
